import React from 'react';

import Link from '../editor/Link'
import Search from '../editor/Search'

const ASpecialDaysCounterEditor = (props) => {
    return (
        <div>
            {props.children}
            <Search />
            <hr />
            <Link value={props.settings.link} />
            <div className="form-group">
                <label className="col-sm-3 control-label">Tytuł</label>
                <div className="col-sm-9">
                    <input type="text" name="title_normal" className="form-control" defaultValue={props.settings.title_normal} placeholder="" />
                </div>
            </div>
        </div>
    );
}


export default ASpecialDaysCounterEditor;